import { UPDATE_SUBSCRIPTION_REQUEST, UPDATE_SUBSCRIPTION_SUCCESS, UPDATE_SUBSCRIPTION_ERROR } from '../types';
import { useHelper } from '../helpers';
export const updateSubscriptionRequest = id => ({
  type: UPDATE_SUBSCRIPTION_REQUEST,
  payload: id
});
export const updateSubscriptionSuccess = _ref => {
  let {
    data
  } = _ref;
  return {
    type: UPDATE_SUBSCRIPTION_SUCCESS,
    payload: {
      data
    }
  };
};
export const updateSubscriptionError = (id, error) => ({
  type: UPDATE_SUBSCRIPTION_ERROR,
  payload: {
    error,
    id
  },
  error: true
});
export const updateSubscription = subscriptionId => function () {
  let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return async (dispatch, getState, _ref2) => {
    let {
      chord
    } = _ref2;
    const {
      withAuth
    } = useHelper(dispatch, getState);
    const input = props;
    dispatch(updateSubscriptionRequest(subscriptionId));
    try {
      const {
        user
      } = getState();
      const userId = user.data.id;
      if (props.lineItemsAttributes) {
        const skus = props.lineItemsAttributes.map(li => li.sku);
        const response = await withAuth(chord.oms.getVariantsBySkus)(skus);
        input.lineItemsAttributes = input.lineItemsAttributes.map(attr => {
          const subscribableId = response?.variants?.find(v => v.sku === attr.sku)?.id;
          return {
            ...attr,
            subscribableId
          };
        });
      }
      const response = await withAuth(chord.oms.updateSubscription)(userId, subscriptionId, input);
      dispatch(updateSubscriptionSuccess({
        data: response
      }));
      return response;
    } catch (error) {
      dispatch(updateSubscriptionError(subscriptionId, error));
      throw error;
    }
  };
};